import api from '../http';
import { AxiosResponse } from 'axios';
import { MyOrder, Order } from '../models/order';


export interface IGetMyOrdersResponse {
    orders: MyOrder[]
}

export interface IGetOrdersResponse {
    orders: Order[]
}

export interface ICreateOrderResponse {
    order_id: number
}


export default class OrderService {
    static async get_my(): Promise<AxiosResponse<IGetMyOrdersResponse>> {
        return await api.get(
            'order'
        );
    };

    static async get(lastSubPrice: number | null, lastOrderId: number | null, salt: string): Promise<AxiosResponse<IGetOrdersResponse>> {
        return await api.get(
            'order/all',
            {params: {
                last_sub_price: lastSubPrice,
                last_order_id: lastOrderId,
                salt: salt
            }}
        );
    };

    static async create(chatId: number, numSub: number, subPrice: number): Promise<AxiosResponse<ICreateOrderResponse>> {
        return await api.post(
            'order',
            {
                chat_id: chatId,
                num_sub: numSub,
                sub_price: subPrice
            }
        ); 
    };

    static async cancel(orderId: number): Promise<AxiosResponse<{}>> {
        return await api.delete(
            'order',
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                data: {order_id: orderId},
            }
        ); 
    };

    static async submit(chatId: number | string, orderId: number): Promise<AxiosResponse<{}>> {
        return await api.post(
            'order/submit',
            {chat_id: chatId, order_id: orderId}
        );
    };
};